<template>
  <div>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="برای جستجوی کالا یا خدمات تایپ کنید"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :loading="loading"
        :items="items"
        :headers="headers"
        class="elevation-1"
        disable-pagination
        hide-default-footer
        show-select
        v-model="selected"
        checkbox-color="primary"
        :single-select="true"
      >
        <template v-slot:[`item.mainImage`]="{ item }">
          <v-img
            :src="item.mainImage.thumbnailFileUrl"
            width="80"
            height="45"
            :alt="item.mainImage.alt"
          ></v-img>
        </template>
         <template v-slot:[`item.categoryType`]="{ item }">
           <span>
          {{ translate(item.categoryType) }}
        </span>
        </template>
        <template v-slot:[`item.name`]="{ item }">
          <span
            style="cursor: pointer"
            icon
            small
            color="primary"
            @click="showSupplierProductInSite(item)"
          >
            <v-icon color="blue" small>mdi-web</v-icon>

            {{ item.name }}</span
          >
        </template>
        <template v-slot:[`item.supplierName`]="{ item }">
          <v-btn
            icon
            small
            color="primary"
            @click="showSupplierPageInSite(item)"
          >
            {{ item.supplierName }}</v-btn
          >
        </template>
      </v-data-table>
    </v-card>
    <div class="text-center mt-2">
      <v-row>
        <v-col cols="12" sm="4" md="2">
          <v-select
            outlined
            dense
            v-model="itemsPerPage"
            :items="[5, 10, 20]"
            label="تعداد نمایش در صفحه"
          ></v-select>
        </v-col>

        <v-col cols="12" sm="8" md="10">
          <v-pagination
            circle
            v-model="pageNumber"
            :length="pageCount"
            :total-visible="7"
          ></v-pagination>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { RepoFactory } from '@/baseRepository/Factory';
const supplierProductRepository = RepoFactory.get('supplierProduct');
import Helper from '@/core/helpers';
import SupplierSaleProductSearch from './SupplierSaleProductSearch.vue';
// import { filter } from 'vue/types/umd';
// const enumsRepository = () => RepoFactory.get('enums');
export default {
  components: {
    SupplierSaleProductSearch,
  },

  data() {
    return {
      loading: false,
      items: [],
      itemsPerPage: 10,
      pageNumber: 1,
      pageCount: 0,
      selected: [],
      search: '',
      categoryId: 0,
      searching: false,
      searchFilterParams: null,
      headers: [
        { text: 'تصویر ', value: 'mainImage' },
        { text: 'حوزه ', value: 'categoryType' },
        { sortable: true, text: 'نام ', value: 'name' },
        { sortable: true, text: 'فروشنده/تامین‌کننده', value: 'supplierName' },
        // {
        //   text: 'عملیات',
        //   value: 'operation',
        //   align: 'left',
        // },
      ],
      statusItem: [],
      selectedSupplierProduct: null,
    };
  },
  computed: {
    productBaseUrl() {
      return this.$store.getters.productBaseUrl;
    },
    // merchantId() {
    //   return this.$store.getters.currentMerchant;
    // },
  },
  created() {
    this.pageNumber = 1;
    this.itemsPerPage = 5;
    this.getSupplierProducts(this.pageNumber, this.itemsPerPage);
  },

  watch: {
    pageNumber(after, before) {
      this.getSupplierProducts(after, this.itemsPerPage);
    },
    itemsPerPage(after, before) {
      this.getSupplierProducts(this.pageNumber, after);
    },
    search(after, before) {
      if (!this.searching) {
        this.searching = true;
        setTimeout(() => {
          this.getSupplierProducts(this.pageNumber, this.itemsPerPage);
          this.searching = false;
        }, 1000);
      }
    },
    selected(after, before) {
       this.$emit('selectedDataFunc', after); 
    }
  },
  methods: {
    showSupplierPageInSite(item) {
      let str = item.supplierName.replace(/\s+/g, '-').toLowerCase();
      let pageUrl =
        this.$store.getters.taksaanUrl +
        '/supplier/' +
        item.supplierId +
        '/' +
        str;
      window.open(pageUrl, '_blank');
    },
    searchList(searchParams) {
      this.pageNumber = 1;
      this.searchFilterParams = searchParams;
      this.getSupplierSaleProducts(this.pageNumber, this.itemsPerPage);
    },
    showSupplierProductInSite(item) {
      this.setSelectedItem(item);
      let str = item.name.replace(/\s+/g, '-').toLowerCase();
      let pageUrl =
        this.$store.getters.taksaanUrl + '/products/' + item.id + '/' + str;
      window.open(pageUrl, '_blank');
    },

    getSupplierProducts(pageNumber = 1, itemsPerPage = 10) {
      if (this.search.length < 2) {
        this.searching = false;
        if (this.search.length == 0) {
          this.items = [];
          return;
        }
        return;
      }

      const loader = this.$loading.show();

      this.loading = true;
      this.pageNumber = pageNumber;
      this.itemsPerPage = itemsPerPage;

      let params = {
        PageNumber: pageNumber,
        ItemsPerPage: itemsPerPage,
        key: this.search,
        ...this.searchFilterParams,
      };

      supplierProductRepository
        .getSupplierSaleProducts(this.productBaseUrl, {}, params)
        .then((res) => {
          this.pageCount = Math.ceil(res.data.totalCount / itemsPerPage);
          this.items = res.data.list;
          this.loading = false;
          loader.hide();
        })
        .catch((error) => {
          this.loading = false;
          loader.hide();
          Helper.handleErrors(error, this);
        });
    },
    setSelectedItem(item) {
     
      this.categoryId = item.categoryId;
    },
    // selecteddata() {
     
    //   this.$emit('selectedDataFunc', this.selected);
     
    // },
     translate(en) {
      const Fa = {
        IndustrialService: "ساخت و تولید",
        Product: "کالای صنعتی",
        ConsultingService: "طراحی و مشاوره صنعتی",
        ElectronicDocument: "استانداردهای صنعتی",
      };
      return Fa[en];
    },
  },
};
</script>

<style scoped></style>
